const swiperSlide = [
{
    img:'https://images-eu.ssl-images-amazon.com/images/G/31/imgg/hero/1499/30th/nov/hero1300x1200._CB572143637_.jpg'
},
{
    img:'https://images-eu.ssl-images-amazon.com/images/G/31/img22/Wireless/devjyoti/GW/Uber/Nov/D103625178_DesktopTallHero_3000x1200._CB574597993_.jpg'
},
{
    img:'https://images-eu.ssl-images-amazon.com/images/G/31/img22/WLA/2023/Unrec/R3/D91435399_WLA-BAU-Unrec-Hero_DesktopTallHero_3000x1200._CB577798844_.jpg'
}
]

export default swiperSlide